import { useState } from 'react'
import { refreshCatalogue } from './catalogue'

/** A link that fails on a catalogue at least this old triggers a reload; a newer one is truly broken. */
export const IMAGE_RETRY_MIN_AGE_MS = 30 * 1000

/**
 * BUG-522: the image of a catalogue-backed line (basket, checkout summary, receipt). Product image
 * links are signed for 15 minutes; when one fails to load, the hook hides it (the caller shows its
 * placeholder) and reloads the catalogue, whose fresh link then replaces it. The same link coming
 * back stays hidden, so a broken image never loops.
 */
export function useCatalogueImage(url: string | null): { src: string | null; onError: () => void } {
  const [failed, setFailed] = useState<string | null>(null)
  const src = url !== null && url !== failed ? url : null
  const onError = () => {
    setFailed(url)
    void refreshCatalogue(IMAGE_RETRY_MIN_AGE_MS)
  }
  return { src, onError }
}
